import { styled } from "@linaria/react"

const colors: Record<AlertType, string> = {
  error: "255, 0, 0",
  warning: "255, 184, 0",
  success: "0, 255, 0",
  info: "0, 125, 255",
}

const Alert = styled.div<Props>`
  font-size: 1rem;
  font-weight: 400;
  padding: 1.1rem 1.2rem;
  background-color: rgba(${(props) => colors[props.type || "error"]}, 0.15);
  color: rgb(${(props) => colors[props.type || "error"]});
  margin-bottom: ${(props) =>
    props.bottomSpace ? (typeof props.bottomSpace === "string" ? props.bottomSpace : "1rem") : "0"};
  margin-top: ${(props) =>
    props.topSpace ? (typeof props.topSpace === "string" ? props.topSpace : "1rem") : "0"};
  transition: all 0.17s ease-in-out;
  border-radius: var(--mui-shape-borderRadius);
`

type AlertType = "error" | "warning" | "success" | "info"

interface Props {
  type: AlertType
  topSpace?: boolean | string
  bottomSpace?: boolean | string
}

export default Alert
